import { useNavigate } from 'react-router-dom';

let navigate = () => assert(false, 'Attempted history nav before init!');

export function NavigateSetter({ children }) {
  navigate = useNavigate();

  return children;
}

export default NavigateSetter;

export { navigate };
